// user avatar
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Drawer } from 'antd';

import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

export default function UserAvatar(props) {
  
  const form = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const list =  [
    {memo: 'Profile', icon: 'bx bx-face', link: `/${form}/profile`},
    {memo: 'Settings', icon: 'bx bx-cog', link: `/${form}/settings`},
    {memo: 'Switch Accounts', icon: 'bx bx-user-circle', link: '/auth/next'},
    {memo: 'Logout', icon: 'bx bx-minus-circle', link: '/auth/x'}
  ]

  const history = useHistory();
  const [drawer, setDrawer] = useState(false)

  return (
    <>
      <div className='py-1' onClick={()=>setDrawer(!drawer)}  style={{cursor:'pointer'}} >
        {
          asset
          ? <Jazzicon diameter={30} seed={jsNumberForAddress(asset.usid)} /> 
          : <Jazzicon diameter={30} seed={jsNumberForAddress(Date.now().toString())} /> 
        }
      </div>

      <Drawer 
        title="My Account" 
        placement="right" 
        width={330}
        footer= {`${process.env.REACT_APP_WEBB_SITE_NAME} - ${process.env.REACT_APP_WEBB_SITE_LINE}`}
        bodyStyle={{margin:'0', padding:'0', backgroundColor:'#F5F8FA'}}
        headerStyle={{backgroundColor:'#ECF1F4', color:'white', margin:'0', padding:'0', height:'3.7rem'}}
        closeIcon= {''}
        onClose={()=>setDrawer(false)} 
        extra={
          <div className='me-3' onClick={()=>setDrawer(false)} style={{cursor:'pointer'}} >
            <i className='bx bx-x text-icon-md text-color-tint'></i>
          </div>
        }
        visible={drawer} >
        
        {/* user actions */}
        <div className='p-3'>
          <div className='mb-2'>
            <h4 className='text-color-main m-0'>{asset ? asset.name : 'Alice Wonderland'}</h4>
            <p className='m-0'>{asset ? asset.mail : 'alice@minti.fi'}</p>
            <p className='m-0'>{form === 'in' ? 'Personal' : 'Business'} Account</p>
          </div>
          <div className='border-bottom mb-2'></div>

          <div className=''>
          {list && list.map((item, i) => (
            <div className='py-1 hitext border-bottom cursor' key={i}
              onClick={()=>history.push(item.link)} 
            >
              <Row justify="space-between">
                <Col span={21}>
                  <Row justify="start" align="middle">
                    <Col>
                      <i className={`${item.icon} lead m-0 text-icon-sm`}></i>
                    </Col >
                    <Col flex="auto" className="mx-1">{item.memo}</Col>
                  </Row>
                </Col>

                <Col span={3} className="text-end">
                  <i className={`bx bx-chevron-right text-color-tint m-0 text-icon-sm`}></i>
                </Col>
              </Row>
            </div>
          ))}
          </div>


        </div>
       </Drawer>

    </>
  )
}